import { SET_BANK_ACCOUNT_DETAILS } from "./bankAccountsActions";

export const bankAccounts = (state = { accounts: [] }, action) => {
    switch (action.type) {
        case SET_BANK_ACCOUNT_DETAILS:
            return { ...state, accounts: Object.values(action.bankAccounts) };

        default:
            return state;
    }
};
